import React, { useState, useEffect } from "react";
import { payForSale, clearError, clearMessage } from "../redux/saleSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCustomer } from "../redux/customerSlice";

const PaySaleModel = ({ visible, onCancel, status, paingamount }) => {
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(null);
  const [customer_name, setCustomer_name] = useState(null);
  const [customer_phone, setCustomer_phone] = useState(null);
  const [customer_address, setCustomer_address] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const { loading, error, message } = useSelector(
    (state) => state.manageProduct
  );
  const { customers } = useSelector((state) => state.customer);

  useEffect(() => {
    dispatch(getCustomer());
  }, []);
  useEffect(() => {
    if (selectedCustomer) {
      setCustomer_name(selectedCustomer.name);
      setCustomer_phone(selectedCustomer.phone);
      setCustomer_address(selectedCustomer.address);
    }
  }, [selectedCustomer]);

  const onConfirm = () => {
    if (
      (!amount || !customer_name || !customer_phone || !customer_address) &&
      status !== "cancel"
    ) {
      alert("Enter details");
    }
    if (status === "cancel") {
      setAmount(0);
    }
    if (Number(amount) > paingamount()) {
      alert("Enter amount less than max");
    }
    const total_amount = paingamount();
    const payData = {
      amount,
      status,
      total_amount,
      customer_name,
      customer_phone,
      customer_address,
    };
    dispatch(payForSale(payData));
    onCancel();
  };

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }
    if (message) {
      alert(message);
      dispatch(clearMessage());
    }
  }, [error, message, dispatch]);

  const handleChange = (event) => {
    const selectedCustomerName = event.target.value;
    const customerObject = customers.find(
      (customer) => customer.name === selectedCustomerName
    );
    setSelectedCustomer(customerObject);
  };
  return (
    visible && (
      <div className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg w-1/3 min-w-[300px]">
          {status === "full" ? (
            <p className="text-base text-gray-900 font-bold mb-4 text-center">
              Amount you have to pay: full amount of Rs{paingamount()}
            </p>
          ) : status === "discount" ? (
            <p className="text-base text-gray-900 font-bold mb-4 text-center">
              Amount you have to pay: less than Rs{paingamount()}
            </p>
          ) : (
            <p className="text-base text-gray-900 font-bold mb-4 text-center">
              Are you sure you want to cancel the order?
            </p>
          )}
          {status !== "cancel" && (
            <div>
              <div className="mb-4">
                <label className="block mb-2">Amount</label>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Amount"
                  className="border p-2 rounded-md w-full"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Select Customer</label>
                <select
                  onChange={handleChange}
                  className="border p-2 rounded-md w-full"
                >
                  <option value="">Select a customer</option>
                  {customers?.map((customer) => (
                    <option key={customer.id} value={customer.name}>
                      {customer.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block mb-2">Customer Name</label>
                <input
                  value={customer_name}
                  onChange={(e) => setCustomer_name(e.target.value)}
                  placeholder="Name"
                  className="border p-2 rounded-md w-full"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Customer Phone</label>
                <input
                  type="number"
                  value={customer_phone}
                  onChange={(e) => setCustomer_phone(e.target.value)}
                  placeholder="Phone"
                  className="border p-2 rounded-md w-full"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Customer Address</label>
                <input
                  value={customer_address}
                  onChange={(e) => setCustomer_address(e.target.value)}
                  placeholder="Address"
                  className="border p-2 rounded-md w-full"
                />
              </div>
            </div>
          )}
          <div className="flex justify-between gap-4">
            <button
              onClick={onCancel}
              className="flex-1 bg-gray-300 py-2 rounded-md text-center"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 bg-green-500 py-2 rounded-md text-white text-center"
            >
              {loading ? "...Loading" : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default PaySaleModel;
